// removed by extract-text-webpack-plugin
module.exports = {"getHelpWrapper":"G3c6fc9"};